import { Combobox, Option } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { SortHelper } from "../../SortHelper";
import { ProjectAssigment } from "../../store/Data";
import { useEditorStyles } from "../Styles/Editor";

type ProjectAssignmentDropdownProps = {
    setProjectAssigment: (projectAssigment?: ProjectAssigment) => void;
    currentProjectAssigment?: ProjectAssigment;
    projectAssigments: ProjectAssigment[];
    ariaInvalid?: boolean;
    disabled?: boolean
};

export const ProjectAssignmentDropdown: React.FC<ProjectAssignmentDropdownProps> = ({ setProjectAssigment, currentProjectAssigment, projectAssigments, ariaInvalid, disabled }) => {
    // Filters
    const [Filter, setFilter] = React.useState<ProjectAssigment[]>([]);
    const [Search, setSearch] = React.useState<string | undefined>();
    // Other
    const { t } = useTranslation();
    const styles = useEditorStyles();
    // Initial load
    React.useEffect(() => {
        setFilter(projectAssigments);
    }, [projectAssigments]);
    return <Combobox
        className={styles.fluid}
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        freeform
        placeholder={t('SelectProjectAssigment')}
        onChange={(event) => {
            const value = event.target.value.trim();
            const matches = projectAssigments.filter(
                (c) => (c.displayName !== null && c.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
            );
            setFilter(matches);
            if (value.length && matches.length < 1) {
                setSearch(value);
                setProjectAssigment(undefined);
            } else if (value.length && matches.length === 1) {
                setSearch(value);
                setProjectAssigment(matches[0]);
            } else {
                setSearch(undefined);
                setProjectAssigment(undefined);
            }
        }}
        onOptionSelect={(event, data) => {
            if (data.optionValue) {
                const matchingOption = projectAssigments.find(c => c.projectAssignmentid === data.optionValue);
                if (matchingOption) {
                    setSearch(undefined);
                    if (matchingOption.projectAssignmentid !== currentProjectAssigment?.projectAssignmentid) {
                        setProjectAssigment(matchingOption);
                    }
                    setFilter(projectAssigments);
                } else {
                    setSearch(data.optionText);
                }
            }
        }}
        defaultValue={currentProjectAssigment && currentProjectAssigment.displayName ? currentProjectAssigment.displayName : undefined}
        defaultSelectedOptions={currentProjectAssigment && currentProjectAssigment.projectAssignmentid ? [currentProjectAssigment.projectAssignmentid] : undefined}
        aria-invalid={ariaInvalid}
        disabled={disabled}
    >
        {Search ? (
            <Option key="freeform" text={Search}>
                Search for "{Search}"
            </Option>
        ) : null}
        {Filter.sort(SortHelper.ProjectAssigmentByName).map((p) => (
            <Option key={p.projectAssignmentid} value={p.projectAssignmentid !== null ? p.projectAssignmentid : ""}>{p.displayName !== null ? p.displayName : "-- ? --"}</Option>
        ))}
    </Combobox>;
};